import { BaseTour } from "@src/widgets/onboarding/classes/BaseTour"
import { ManualPayoutsStep } from "@src/widgets/onboarding/classes/tours/MassCryptoTour/steps/ManualPayoutsStep"
import { MassPayoutsStep } from "@src/widgets/onboarding/classes/tours/MassCryptoTour/steps/MassPayoutsStep"
import { ONBOARDING_TOURS } from "@src/widgets/onboarding/types"

export class MassCryptoTour extends BaseTour {
  name = ONBOARDING_TOURS.MASS_CRYPTO

  steps = [new MassPayoutsStep(), new ManualPayoutsStep()]
}
